import { CanNumberModel } from './../../../../api/models/can-number-model';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'ndms-can-number-edit',
  templateUrl: './can-number-edit.component.html',
  styleUrls: ['./can-number-edit.component.css']
})
export class CanNumberEditComponent {
  @Output() save = new EventEmitter<CanNumberModel>();
  @Output() cancel = new EventEmitter<boolean>();
  @Input() set model(canNumber: CanNumberModel) {
    this.canNumber = Object.assign({}, canNumber);
    this.formGroup.patchValue(this.canNumber);
  }

  modelError = "";
  canNumber: CanNumberModel;
  formGroup: FormGroup;

  get id() {
    return this.formGroup.get("id");
  }

  get canNumberDescription() {
    return this.formGroup.get("canNumberDescription");
  }

  get canNumberName() {
    return this.formGroup.get("canNumberName");
  }

  get active() {
    return this.formGroup.get("active");
  }

  get isIpr() {
    return this.formGroup.get("isIpr");
  }

  get editWarning() {
    let msg = ""
    if (this.canNumber?.canNumberRostersCount || this.canNumber?.canNumberIprRequestsCount) {
      msg = "WARNING: This CAN is currently assigned to ";
      if (this.canNumber.canNumberRostersCount) msg += this.canNumber.canNumberRostersCount + " roster" + (this.canNumber.canNumberRostersCount > 1 ? 's' : '');
      if (this.canNumber.canNumberRostersCount && this.canNumber.canNumberIprRequestsCount) msg += " and ";
      if (this.canNumber.canNumberIprRequestsCount) msg += this.canNumber.canNumberIprRequestsCount + " IPR request" + (this.canNumber.canNumberIprRequestsCount > 1 ? 's' : '');
      msg += ". Are you sure you want to edit this CAN?";
    }
    return msg;
  }

  constructor(private _formBuilder: FormBuilder) {
    this.formGroup = this._formBuilder.group({
      id: null,
      canNumberDescription: ["", Validators.required],
      canNumberName: ["", Validators.required],
      isIpr: false,
      active: true
    });
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onSaveClick() {
    this.save.emit(Object.assign({}, this.canNumber, this.formGroup.value));
  }
}
